import { UserActionTypes } from "./types";

const initialState = {
  profile: {},
  error: null,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case UserActionTypes.GET_PROFILE_SUCCESS:
      return {
        ...state,
        profile: payload.profile,
      };
    case UserActionTypes.EDIT_USER_SUCCESS:
      return {
        ...state,
        profile: payload.user,
      };
    case UserActionTypes.DELETE_USER_SUCCESS:
      return {
        ...state,
        profile: {},
      };
    default:
      return state;
  }
}
